import React from 'react';
import Icon from '../../../components/AppIcon';

const FeatureHighlights = () => {
  return (
    <section className="py-24 relative overflow-hidden" style={{background: '#0f1f3d'}}>
      {/* Background texture */}
      <div className="absolute inset-0 opacity-[0.03]" style={{backgroundImage: 'linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)', backgroundSize: '40px 40px'}}></div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-6 px-4 py-2 rounded-full text-sm font-bold uppercase tracking-widest" style={{background: 'rgba(45,212,191,0.15)', color: '#2dd4bf', border: '1px solid rgba(45,212,191,0.3)'}}>
            <Icon name="Star" size={14} />
            Feature Highlights
          </div>
          <h2 className="font-heading font-bold text-white leading-tight mb-5" style={{fontSize: 'clamp(2rem, 4vw, 3rem)'}}>
            Everything in one place
          </h2>
          <p className="text-lg max-w-xl mx-auto" style={{color: 'rgba(255,255,255,0.6)'}}>
            Each piece of Cynizee is designed to work together — from assignment to approval.
          </p>
        </div>

        {/* Asymmetric bento grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 auto-rows-auto">
          
          {/* Card 1: Chore Assignment — tall */}
          <div className="sm:row-span-2 rounded-3xl p-8 flex flex-col justify-between relative overflow-hidden" style={{background: 'linear-gradient(160deg, #2dd4bf 0%, #0d9488 100%)', minHeight: '280px'}}>
            <div className="absolute -bottom-8 -right-8 w-40 h-40 rounded-full opacity-20" style={{background: '#fff'}}></div>
            <div>
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-6" style={{background: 'rgba(255,255,255,0.2)'}}>
                <Icon name="ClipboardList" size={28} className="text-white" />
              </div>
              <h3 className="font-heading font-bold text-white text-xl mb-3">Chore Assignment</h3>
              <p className="leading-relaxed" style={{color: 'rgba(255,255,255,0.85)'}}>
                Assign chores to the right child with clear expectations and due times. No more confusion about who does what.
              </p>
            </div>
            <div className="mt-6 flex items-center gap-2 text-sm font-semibold" style={{color: 'rgba(255,255,255,0.7)'}}>
              <Icon name="ArrowRight" size={16} />
              <span>Assign in seconds</span>
            </div>
          </div>

          {/* Card 2: Progress Tracking */}
          <div className="rounded-3xl p-7 relative overflow-hidden" style={{background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)'}}>
            <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-5" style={{background: 'rgba(245,158,11,0.2)'}}>
              <Icon name="Activity" size={22} style={{color: '#f59e0b'}} />
            </div>
            <h3 className="font-heading font-bold text-white text-lg mb-2">Progress Tracking</h3>
            <p className="text-sm leading-relaxed" style={{color: 'rgba(255,255,255,0.6)'}}>
              Kids can see what they need to do and track their progress step by step.
            </p>
          </div>

          {/* Card 3: Smart Accountability — wide */}
          <div className="rounded-3xl p-7 relative overflow-hidden" style={{background: 'linear-gradient(135deg, #ff6b6b 0%, #ff4444 100%)'}}>
            <div className="absolute top-0 right-0 w-32 h-32 rounded-full opacity-20 blur-2xl" style={{background: '#fff'}}></div>
            <div className="relative z-10">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{background: 'rgba(255,255,255,0.2)'}}>
                  <Icon name="Lock" size={22} className="text-white" />
                </div>
                <div className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-bold" style={{background: 'rgba(255,255,255,0.2)', color: '#fff'}}>
                  ⭐ Key Feature
                </div>
              </div>
              <h3 className="font-heading font-bold text-white text-lg mb-2">Smart Accountability</h3>
              <p className="text-sm leading-relaxed" style={{color: 'rgba(255,255,255,0.85)'}}>
                Favorite apps stay locked until chores are done. Real consequences, real follow-through.
              </p>
            </div>
          </div>

          {/* Card 4: Proof of Completion */}
          <div className="rounded-3xl p-7" style={{background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)'}}>
            <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-5" style={{background: 'rgba(167,139,250,0.2)'}}>
              <Icon name="Camera" size={22} style={{color: '#a78bfa'}} />
            </div>
            <h3 className="font-heading font-bold text-white text-lg mb-2">Proof of Completion</h3>
            <p className="text-sm leading-relaxed" style={{color: 'rgba(255,255,255,0.6)'}}>
              Children submit photo proof before a chore is marked complete. No more "I did it" without evidence.
            </p>
          </div>

          {/* Card 5: Parent Approval */}
          <div className="rounded-3xl p-7 relative overflow-hidden" style={{background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'}}>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 rounded-full opacity-20" style={{background: '#0f1f3d'}}></div>
            <div className="relative z-10">
              <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-5" style={{background: 'rgba(255,255,255,0.2)'}}>
                <Icon name="ThumbsUp" size={22} className="text-white" />
              </div>
              <h3 className="font-heading font-bold text-white text-lg mb-2">Parent Approval</h3>
              <p className="text-sm leading-relaxed" style={{color: 'rgba(255,255,255,0.85)'}}>
                Parents review submitted chores and decide whether they are truly complete.
              </p>
            </div>
          </div>

          {/* Card 6: AI Grocery List — wide */}
          <div className="sm:col-span-2 lg:col-span-2 rounded-3xl p-7 relative overflow-hidden" style={{background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)'}}>
            <div className="absolute top-0 right-0 w-40 h-40 rounded-full opacity-20 blur-2xl" style={{background: '#fff'}}></div>
            <div className="relative z-10">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{background: 'rgba(255,255,255,0.2)'}}>
                  <Icon name="ShoppingCart" size={22} className="text-white" />
                </div>
                <div className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-bold" style={{background: 'rgba(255,255,255,0.2)', color: '#fff'}}>
                  🤖 AI-Powered
                </div>
              </div>
              <h3 className="font-heading font-bold text-white text-xl mb-2">AI Grocery List</h3>
              <p className="text-sm leading-relaxed" style={{color: 'rgba(255,255,255,0.85)'}}>
                Just point your camera — Cynizée's AI identifies products, reads list text, and suggests grocery items from what it sees. Perfect for kids who struggle with writing or reading to add things to the list without typing a single word.
              </p>
              <div className="mt-4 flex items-center gap-2 text-sm font-semibold" style={{color: 'rgba(255,255,255,0.7)'}}>
                <Icon name="ArrowRight" size={16} />
                <span>Smart lists, every week</span>
              </div>
            </div>
          </div>

          {/* Card 7: Chore Swaps */}
          <div className="rounded-3xl p-7 relative overflow-hidden" style={{background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)'}}>
            <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-5" style={{background: 'rgba(45,212,191,0.2)'}}>
              <Icon name="ArrowLeftRight" size={22} style={{color: '#2dd4bf'}} />
            </div>
            <h3 className="font-heading font-bold text-white text-lg mb-2">Chore Swaps</h3>
            <p className="text-sm leading-relaxed" style={{color: 'rgba(255,255,255,0.6)'}}>
              Kids can trade chores with siblings in a fair, parent-approved way — turning arguments into teamwork and teaching real negotiation skills.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default FeatureHighlights;
